export var DataCatalogIssueSeverity;
(function (DataCatalogIssueSeverity) {
    DataCatalogIssueSeverity["DATA_CATALOG_ISSUE_SEVERITY_ERROR"] = "ERROR";
    DataCatalogIssueSeverity["DATA_CATALOG_ISSUE_SEVERITY_WARNING"] = "WARNING";
})(DataCatalogIssueSeverity || (DataCatalogIssueSeverity = {}));
